import { render, staticRenderFns } from "./F7app.vue?vue&type=template&id=00fa57a3&scoped=true&"
import script from "./F7app.vue?vue&type=script&lang=js&"
export * from "./F7app.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./F7app.vue?vue&type=style&index=0&id=00fa57a3&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "00fa57a3",
  "36ae2bf8"
  
)

export default component.exports